import { render, staticRenderFns } from "./Xgzs.vue?vue&type=template&id=2598332a&scoped=true"
import script from "./Xgzs.vue?vue&type=script&lang=js"
export * from "./Xgzs.vue?vue&type=script&lang=js"
import style0 from "./Xgzs.vue?vue&type=style&index=0&id=2598332a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598332a",
  null
  
)

export default component.exports